const organizations = {
    title: 'Organisationen',
    description: 'Erstellen und verwalten Sie die Organisationen, denen Sie angehören.',
    create: 'Organisation erstellen',
    create_title: 'Neue Organisation erstellen',
    name: 'Organisationsname',
    avatar: 'Organisationsavatar',
    avatar_removed: 'Organisationsavatar entfernt.',
    description_label: 'Beschreibung',
    empty: 'Sie gehören noch keiner Organisation an.',
    pending_invitations: 'Ausstehende Einladungen',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    owner: 'Inhaber',
    tabs: {
        overview: 'Übersicht',
        members: 'Mitglieder',
        invitations: 'Einladungen',
        roles: 'Verwaltungsrollen',
        branding: 'Markenauftritt',
        security: 'Sicherheit',
        jit: 'JIT-Bereitstellung',
        applications: 'Freigegebene Ressourcen',
        activity: 'Aktivität',
        deletion: 'Löschen',
    },
    members: {
        title: 'Mitglieder',
        empty: 'Keine Mitglieder gefunden.',
        remove: 'Entfernen',
        removed: 'Mitglied entfernt.',
        business_roles: 'Geschäftsrollen',
        no_business_roles: 'Keine Geschäftsrollen verfügbar. Bitten Sie Ihren Mandantenadministrator, Rollen für diese Organisation freizugeben.',
    },
    invitations: {
        title: 'Einladungen',
        invite: 'Mitglied einladen',
        email: 'E-Mail-Adresse',
        empty: 'Keine Einladungen gefunden.',
        resend: 'Erneut senden',
        resent: 'Einladung erneut gesendet.',
        revoke: 'Widerrufen',
        revoked: 'Einladung widerrufen.',
        status: {
            Pending: 'Ausstehend',
            Accepted: 'Angenommen',
            Expired: 'Abgelaufen',
            Revoked: 'Widerrufen',
            Declined: 'Abgelehnt',
        },
    },
    roles: {
        title: 'Verwaltungsrollen',
        create: 'Rolle erstellen',
        permissions: 'Berechtigungen',
        empty: 'Keine Verwaltungsrollen gefunden.',
        select_member: 'Mitglied auswählen',
        select_role: 'Rolle auswählen',
        assign: 'Rolle zuweisen',
        assigned: 'Rolle zugewiesen.',
        unassign: 'Rolle entfernen',
        unassigned: 'Rolle entfernt.',
        permission_count: 'Berechtigungen: {{count}}',
        built_in: {
            owner: 'Inhaber',
            owner_description: 'Inhaber haben exklusive Rechte zur Verwaltung der Inhaberschaft und zum Löschen der Organisation.',
            administrator: 'Administrator',
            administrator_description: 'Verwaltet die Organisation mit Ausnahme der Aktionen, die Inhabern vorbehalten sind.',
        },
        permission_labels: {
            update_profile: 'Profil aktualisieren',
            manage_branding: 'Markenauftritt verwalten',
            view_members: 'Mitglieder anzeigen',
            manage_members: 'Mitglieder verwalten',
            manage_invitations: 'Einladungen verwalten',
            assign_business_roles: 'Geschäftsrollen zuweisen',
            manage_management_roles: 'Verwaltungsrollen verwalten',
            assign_management_roles: 'Verwaltungsrollen zuweisen',
            manage_security: 'Sicherheit verwalten',
            manage_jit: 'JIT-Bereitstellung verwalten',
            manage_applications: 'Anwendungen verwalten',
            view_activity: 'Aktivität anzeigen',
        },
    },
    branding: {
        title: 'Markenauftritt der Organisation',
        primary_color: 'Primärfarbe',
        custom_css: 'Benutzerdefiniertes CSS',
        preview: 'Vorschau',
        light: 'Hell',
        dark: 'Dunkel',
    },
    security: {
        title: 'Organisationssicherheit',
        require_mfa: 'Mehrfaktor-Authentifizierung für Mitglieder verlangen',
    },
    jit: {
        title: 'JIT-E-Mail-Domains',
        domain: 'E-Mail-Domain',
        add: 'Domain hinzufügen',
        verify: 'DNS prüfen',
        dns_instruction: 'Erstellen Sie den TXT-Eintrag {{record}} mit dem Wert {{value}}.',
        verified: 'Verifiziert',
    },
    applications: {
        title: 'Freigegebene Ressourcen',
        empty: 'Für diese Organisation sind keine Ressourcen verfügbar.',
        sso: 'Unternehmens-SSO-Verbindungen',
        m2m: 'Maschine-zu-Maschine-Anwendungen',
    },
    activity: {
        title: 'Organisationsaktivität',
        empty: 'Noch keine Aktivität.',
        events: {
            create: 'Organisation erstellt',
            delete: 'Organisation gelöscht',
            profile: 'Organisationsprofil aktualisiert',
            branding: 'Markenauftritt aktualisiert',
            security: 'Organisationssicherheit aktualisiert',
            member_add: 'Mitglied hinzugefügt',
            member_remove: 'Mitglied entfernt',
            owner: 'Inhaberschaft aktualisiert',
            role_create: 'Verwaltungsrolle erstellt',
            role_update: 'Verwaltungsrolle aktualisiert',
            role_delete: 'Verwaltungsrolle gelöscht',
            role_assign: 'Verwaltungsrolle zugewiesen',
            role_unassign: 'Verwaltungsrolle vom Mitglied entfernt',
            business_role: 'Geschäftsrollen aktualisiert',
            invitation_create: 'Einladung gesendet',
            invitation_accept: 'Einladung angenommen',
            invitation_decline: 'Einladung abgelehnt',
            invitation_revoke: 'Einladung widerrufen',
            jit: 'JIT-Bereitstellung aktualisiert',
            domain: 'E-Mail-Domain-Verifizierung',
            application: 'Anwendungsverbindungen aktualisiert',
            unknown: 'Organisationsaktivität',
        },
    },
    save: 'Änderungen speichern',
    cancel: 'Abbrechen',
    delete: 'Organisation löschen',
    delete_confirmation: 'Die Organisation und ihre Mitgliedschaften werden dauerhaft gelöscht. Geben Sie zur Bestätigung „{{name}}“ ein.',
    deleted: 'Organisation gelöscht.',
    load_failed: 'Organisationsdaten konnten nicht geladen werden. Versuchen Sie es erneut.',
    permission_denied: 'Sie haben keine Berechtigung, diesen Bereich anzuzeigen.',
};
export default organizations;
